import React from 'react'
import { Box, Typography } from '@mui/material'

const FilterPill = ({ isSelected, label = 'Default Label', onSelect }) => {
  return (
    <Box
      sx={{
        border: '2px solid',
        borderColor: isSelected ? 'primary.main' : 'grey1',
        borderRadius: '40px',
        padding: '8px 50px',
        width: 'fit-content',
        cursor: 'pointer'
      }}
      onClick={() => onSelect(label)}
    >
      <Typography
        variant='med_14_500'
        sx={{
          color: isSelected ? 'primary.main' : 'black'
        }}
      >{label}
      </Typography>
    </Box>
  )
}

export default FilterPill
